import React, { useState, useEffect } from "react";
import * as Perks from "@plans/tiles";
import { connect } from "react-redux";
import { Modal, ModalTitle, ModalBody, ModalFooter } from "@vds/modals";
import { RadioButtonGroup } from '@vds/radio-buttons';
import { Pricing } from "@plans/type-lockups"
import { PerkDetailModal } from "@plans-templates/perk-details";
import PerkDetailOverlay from "./perkModal";
import { updatePerkSelection } from "../../../action/buildProduct";
import AppleModal from "./appleModal";
import CloudStepDownModal from "./cloudStepDownModal";
import { Button } from '@vds/buttons';
import { InHomeUtils } from "../../../util/change/inhomeUtils";
import { Tooltip } from '@vds/tooltips';
import StartNotification from "./startNotification";
import constants from "./constants";
import { TextLink } from '@vds/buttons';
import { updateSCTags } from './../../../service/dtmTag';
import { Loader } from "@vds/loaders";
import { getVZDLInit, updateVzdlSCCustomEvent, tempVzdlSCData, updateSandboxIdValue, updateFragmentsValue, updateDetailValue } from  './../../../service/vzdl';
import { useMobileView } from '../../../hooks/useMobileView';
import { Body, Title } from '@vds/typography';
import { NetMaxConfirmationModal, PerkAddlInfo } from "../DiscountFlowModal";
import ReactHtmlParser from 'react-html-parser';
import * as buildProductAction from './../../../action/change/buildProduct';
import { focusAnimation } from './../../../action/buildProduct';
import { emberMnHPerkCreditOfferAttributes } from "../../change/perks/constants";
import { Notification } from "@vds/notifications";
import {sunSetPerks} from "../cms/perkSunset";
import  PerkStreamline from "../../../containers/streamlineOrdering/streamlinePerksLite/perkStreamline/index.js";

const YouTubePremiumRemoveModal = React.lazy(() => import("./youtubePremiumRemoveModal"));

const PerkTileComponent = Perks?.Perk;

export const RadioButtonlabel = {
  R3556:"individual subscription",
  R3557:"family subscription",
  R3552:"Unlimited Individual Cloud Storage",
  R3553:"Unlimited Group Cloud Storage",
  R3731:"Home Device Advisor",
  R3784:"Verizon Home Device Protect"
}

export function checkForkGroupProdcutSelectedToOpenTheDrawer(props,selectedProduct){
  let vl= false;
  let groupDefaultValue = null;
   if(InHomeUtils.isNotNull(props?.selectedProduct) &&  InHomeUtils.isNotNull(props?.product) &&
      selectedProduct?.length > 0
  ){
    let collectProdId = props?.product?.perkDetails.map(vl => {return vl.id}) || [];
    vl = props?.selectedProduct?.split(",").some(item =>  collectProdId.includes(item));
    groupDefaultValue = props?.selectedProduct?.split(",").find(item => collectProdId.includes(item));
   }
  return {drawer:vl,defaultValue:groupDefaultValue};
}

const PerkTile = (props) => {
  const { product, perkList, perkListobj, visitId, flowType, dispatch, buildProduct, selectedProduct, cart, profileCart, ecProfileCart, movesShowPerksOverlay = false} = props;
  const [add, setAdd] = useState(false);
  const [showPerksOverlay, setPerksOverlayState] = useState(movesShowPerksOverlay ? movesShowPerksOverlay :false);
  const [perkInfo, setPerkInfo] = useState(null);  
  const [perkRecLabel, setPerkRecLabel] = useState("");
  const [showAppleModal,setShowAppleModal] = useState(false);
  const [exisitngAppleProduct,setExisitngAppleProduct] = useState("");
  const [showAppleInfoModal,setShowAppleInfoModal] = useState(false);
  const [showGoogleOnePremiumAiModal,setShowGoogleOnePremiumAiModal] = useState(false);
  const groupPerks = checkForkGroupProdcutSelectedToOpenTheDrawer(props,props.buildProduct?.perks?.selectedProduct);
  const [showDrawer,setShowDrawer] = useState(groupPerks?.drawer);
  const [prodId,setProdId] = useState('');
  const [groupDefaultValue,setGroupDefaultValue] = useState(groupPerks?.defaultValue);
  const [groupActiveId,setGroupActiveId ]= useState(null);
  const [showNFModal, setshowModal] = useState(false);
  const [showLoader, setLoaderStatus] = useState(false);
  const [disneyModal, setDisneyModal] = useState(false);
  const isMobileView = useMobileView();
  const [togglePerkName, setTogglePerkName] = useState('')
  const [showConflictModal, setShowConflictModal] = useState(false);
  const [conflictFromRadioBtn, setConflictFromRadioBtn] = useState(false);
  const [selectedGrpPerkId, setSelectedGrpPerkId] = useState(groupPerks?.defaultValue);
  const [hasCloudStepDown, setCloudStepDown] = useState(false);
  const [isCloudStepDownModalOpen, setCloudStepDownModalOpen] = useState(false);
  const [cloudStepDownSubmitData, setCloudStepDownSubmitData] = useState(null);
  const [cloudStepDownSource, setCloudStepDownSource] = useState("");
  const [showNetmaxConfirmation, setShowNetmaxConfirmation] = useState(false);
  const [showGrandfatherConfirmation, setshowGrandfatherConfirmation] = useState(false);
  const [grandfatheredPerkId, setgrandfatheredPerkId] = useState('');
  const isGrandfatheredPerk = ['R3558','R3551','R3554'];
  const [isOpened, setOpened] = useState(false);
  const [hasYouTubeRemoveModal, setHasYouTubeRemoveModal] = useState(false);
  const [youTubeRemoveData, setYouTubeRemoveData] = useState(null);
  let wirelessPerks = [];
  const isDisneyTrioSelected = buildProduct?.perks?.selectedProduct?.findIndex?.((item) => item?.prodId === "R4438") > -1 
  const isToggleDisabled = (isDisneyTrioSelected && product?.data?.id ==="R3558") ? true : false;
  let isshowApplePriceUP=(props?.lqState?.runtimeKey?.showApplePriceUP?.toLowerCase() === 'y')?true:false;
  let streamlinePagePerk = window && window.location && window.location.pathname && window.location.pathname.includes('streamlineordering')
  if(props?.buildProduct?.perkMessages && props?.buildProduct?.perkMessages?.length > 0) {
    wirelessPerks = props?.buildProduct?.perkMessages?.filter((list) => list?.msgId?.includes('WIRELESS'))?.map(perk => perk?.applicablePerks);
    console.log('****** wireless perks ', wirelessPerks);
  }

  let isMnHAuthenticated = "";
  let isDuplicateGoogleOnePerk = false;
  const isEmployee = props.lqState.couponFlowType === 'Employee' || props.lqState.couponFlowType === 'Retiree' || props.cart?.cartData[0]?.Promotions?.length > 0 ? (props.cart?.cartData[0]?.Promotions?.promotions?.filter(p => p.offerAttrValue === 'FCP_EMPFLOW_DATA_DISCOUNT')?.length != 0) : false;
  const uniqPerkList = perkList?.filter((product)=> {return !constants.DONOTSHOW_PERK_TILE_GROUP.includes(product?.data?.id)})
  const grandfatheredPerkModalCTAClick = (action,id) =>{
    console.log('***** perk modal action ', action);
    if(action === 'keep') {
      setshowGrandfatherConfirmation(false);
    } else if(action === 'remove') {
      setshowGrandfatherConfirmation(false);
      updatePerkSelection({ prodId: id, add: true, dispatch: dispatch, visitId: visitId })
    }
  };

  if(buildProduct?.internet?.mnhSignupIndicator !== "" && buildProduct?.internet?.mnhSignupIndicator !== null && buildProduct?.internet?.mnhSignupIndicator !== undefined){
    isMnHAuthenticated = buildProduct?.internet?.mnhSignupIndicator
  }

  useEffect(() => {
    displayPerkSelection();
    if (product?.perkDetails?.[0]?.id === constants.YOUTUBE_PREMIUM && buildProduct?.internetToggleYoutubePremium && !cart?.cartData?.[0]?.perks?.perks?.find?.(p => p?.prodId === constants.YOUTUBE_PREMIUM)) {
      dispatch({ type: "TOGGLE_INTERNET_ORDERPERKS_YOUTUBE_PREMIUM", value: false });
      handleToggle();
    }
  }, []);

  useEffect(() => {
    try {
      if (product?.perkDetails?.[0]?.id === constants.YOUTUBE_PREMIUM) {
        const hasYouTubeCart = cart?.cartData?.[0]?.perks?.perks?.find?.(p => p?.prodId === constants.YOUTUBE_PREMIUM);
        const hasYouTubeDiscountCart = cart?.cartData?.[0]?.Promotions?.promotions?.find?.(p => p?.offerAttrValue === "YOUTUBEPREMIUM_PERK_DISCOUNT");
        const hasYouTubeProfile = (profileCart?.cartData?.[0]?.perks?.perks?.find?.(p => p?.prodId === constants.YOUTUBE_PREMIUM) || ecProfileCart?.cartData?.[0]?.perks?.perks?.find?.(p => p?.prodId === constants.YOUTUBE_PREMIUM));
        const hasYouTubeDiscountProfile = (profileCart?.cartData?.[0]?.Promotions?.promotions?.find?.(p => p?.offerAttrValue === "YOUTUBEPREMIUM_PERK_DISCOUNT") || ecProfileCart?.cartData?.[0]?.Promotions?.promotions?.find?.(p => p?.offerAttrValue === "YOUTUBEPREMIUM_PERK_DISCOUNT"));
        if ((hasYouTubeCart && hasYouTubeDiscountCart) || (!(hasYouTubeCart && hasYouTubeDiscountCart) && (hasYouTubeProfile && hasYouTubeDiscountProfile))) {
          if (!hasYouTubeRemoveModal) {
            setHasYouTubeRemoveModal(true);
          }
        } else if (hasYouTubeRemoveModal) {
          setHasYouTubeRemoveModal(false);
        }
      }
    } catch (e) {
      console.error(e);
    }
  }, [cart, profileCart, ecProfileCart]);

  useEffect(() => {
    if (product?.perkDetails?.[0]?.id === constants.YOUTUBE_PREMIUM && cart?.cartData?.[0]?.Promotions?.promotions?.find?.(p => p?.offerAttrValue === "YOUTUBEPREMIUM_PERK_MARKER" || p?.offerAttrValue === "YOUTUBEPREMIUM_PERK_DISCOUNT") && buildProduct?.enablePerkRedesign && props?.lqState?.streamlineLQ) {
      if (!perkRecLabel) {
        setPerkRecLabel(" hasPerkRecommendedLabels");
      }
    } else {
      if (perkRecLabel) {
        setPerkRecLabel("");
      }
    }
  }, [product?.perkDetails?.[0]?.id, buildProduct?.isDisneyPromoPresent, cart?.cartData, buildProduct?.enablePerkRedesign, props?.lqState?.streamlineLQ]);

  useEffect(()=>{
   
    if(props.cart?.cartData?.[0]?.perks?.perks?.length>0){
    let prods = props.cart?.cartData?.[0]?.perks?.perks
    dispatch({ type: 'PERKS_SELECTEDPROD', value: prods});
    }else{
      dispatch({ type: 'PERKS_SELECTEDPROD', value: null});
    }
  },[props?.cart?.cartData])

  /*useEffect(()=>{
    if(props.flowType === "MV"){
      console.log("inside move fn")
      if (
        (props?.profileCart?.cartData[0]?.perks?.perks?.length > 0 &&
          (props.cart?.cartData?.[0]?.removedperks?.removedPerks?.length === 0 ||
            props.cart?.cartData?.[0]?.removedperks?.removedPerks == null)) ||
        props?.buildProduct?.perks?.selectedProduct?.length > 0
      ) {
        let prods =
          props?.profileCart?.cartData[0]?.perks?.perks ||
          props?.buildProduct?.perks?.selectedProduct;
        dispatch({ type: "PERKS_SELECTEDPROD", value: prods });
      }
    }
  },[])*/

  useEffect(() => {
    if(product?.perkDetails?.length >= 2) {
      const grpPerkId = props?.buildProduct?.perks?.selectedProduct?.find(item => (item?.prodId === product?.perkDetails?.[0]?.id) || (item?.prodId === product?.perkDetails?.[1]?.id));
      setSelectedGrpPerkId(grpPerkId ? grpPerkId?.prodId : groupPerks?.defaultValue);
    }
    displayPerkSelection();
  }, [buildProduct.perks.selectedProduct]);

  useEffect(() => {
    const profileCartPerks = props?.profileCart?.cartResponse?.tierContent?.[0]?.sections?.section?.find(sec => sec?.sectionName === "Perks")?.subSections?.subSection?.find(sec => sec?.sectionType === "Perks")?.products;
    setCloudStepDown(
      (buildProduct?.isCloudStepDownEnabled || true)
      && ((product?.perkDetails?.findIndex(p => p?.id === "R3552") > -1 || product?.perkDetails?.findIndex(p => p?.id === "R3553") > -1))
      && Array.isArray(profileCartPerks) && profileCartPerks?.findIndex(c => c?.prodId === "R3553") > -1
    );
  }, [product?.perkDetails, props?.profileCart]);

  // useEffect(() => {
  //   if (product?.data?.id === "R3558" && buildProduct?.perks?.selectedProduct?.findIndex?.((item) => item?.prodId === "R4438") > -1 && isLegacyDisnyRemove()) {
  //     updatePerkSelection({
  //       product,
  //       prodId: "R3558",
  //       add: true,
  //       flowType,
  //       visitId,
  //       dispatch,
  //       isMnHAuthenticated,
  //     });
  //   }
  // }, [isDisneyTrioSelected]);

  const handleClick = () => {
    setPerksOverlayState(!showPerksOverlay);
    console.log('****** perks handle click ');
  };
  const handleClose=() => {
    setshowModal(false);
    updateSCTags('close')
  }

  // const isLegacyDisnyRemove = () => {
  //   const profileCartPerks =
  //     props?.profileCart?.cartResponse?.tierContent?.[0]?.sections?.section
  //       ?.find((sec) => sec?.sectionName === "Perks")
  //       ?.subSections?.subSection?.find(
  //         (sec) => sec?.sectionType === "Perks"
  //       )?.products;

  //   const ecProfileCartPerks =
  //     props?.ecProfileCart?.cartResponse?.tierContent?.[0]?.sections?.section
  //       ?.find((sec) => sec?.sectionName === "Perks")
  //       ?.subSections?.subSection?.find(
  //         (sec) => sec?.sectionType === "Perks"
  //       )?.products;

  //   const DisneyInRemove =
  //     props?.cart?.cartData?.[0]?.removedperks?.removedPerks?.findIndex(
  //       (item) => item?.prodId === "R3558"
  //     ) > -1;

  //   const isLegacyDisnyinProfileCart =
  //     (Array.isArray(ecProfileCartPerks) &&
  //       ecProfileCartPerks?.findIndex((c) => c?.prodId === "R3558") > -1) ||
  //     (Array.isArray(profileCartPerks) &&
  //       profileCartPerks?.findIndex((c) => c?.prodId === "R3558") > -1);

  //   const disneyInCart =
  //     props?.cart?.cartData?.[0]?.perks?.perks?.findIndex(
  //       (c) => c?.prodId === "R3558"
  //     ) > -1;

  //   return (
  //     (isLegacyDisnyinProfileCart && !DisneyInRemove) || (!isLegacyDisnyinProfileCart && disneyInCart)
  //   );
  // };

 

  const OpenGrandfatheredPerkModal = (perkIDGF) => {
    
    let modalTitle = '';
    let modalBody = '';
    let getCMSDataForSunSet = sunSetPerks;
    console.log(getCMSDataForSunSet);
    getCMSDataForSunSet?.Perks?.map(item => {
      if(item?.identifier == perkIDGF.perkIDGF){
        modalTitle = item?.modalTitle;
        modalBody = item?.modalContent;
      }
    });
    
     return (
        <>
    
        <Modal opened={showGrandfatherConfirmation}  id='plusplay_walmart_remove_confirmmodal'>
            <ModalTitle >
            {modalTitle}
            </ModalTitle>
            <ModalBody>
              {modalBody}
           </ModalBody>
           <ModalFooter>
             <Button use='primary' width='48%' display='inline-block'
               onClick={() => grandfatheredPerkModalCTAClick('remove',perkIDGF.perkIDGF)}>Continue</Button>
              &nbsp;&nbsp;&nbsp;
              <Button use='secondary' width='48%' display='inline-block' onClick={() => grandfatheredPerkModalCTAClick('keep',perkIDGF.perkIDGF)}>Cancel</Button>
            </ModalFooter>
           
        </Modal>
        </>  
    )
  }
  const OpenNetFlixModal = () => {

    console.log('DEBUG: in open Modal', showNFModal);
     return (
        <>
    
        <Modal opened={showNFModal} closeButton={null} fullScreenDialog={false}
disableOutsideClick={false}  id='mnTooltip-Modal'>
            <ModalTitle >
            Netflix-Max Premium
            </ModalTitle>
            <ModalBody>
              {/* {text} */}
              Max Premium Channel is subscribed to on account and will not be removed unless requested
           </ModalBody>
           <ModalFooter>
            <button onClick= {()=>handleClose()}>
              Close
            </button>
           </ModalFooter>
           
        </Modal>
        </>  
    )
  }

  const handleToggle = (e, perkinfo) => {
    setLoaderStatus(true);
    // commented out as part of proddef-35601 issue#11 fix
    // setTimeout(() => {
      setLoaderStatus(false);
    // }, 500);
    console.log('DEBUG: handleToggle prodId', product," groupActiveId =",groupActiveId," groupDefaultValue =", groupDefaultValue);
    const isStreamline = props.lqState.streamlineLQ ?? false
    const selectedProduct = props.buildProduct?.perks?.selectedProduct || [];
    const selectedPerk = selectedProduct?.find(item =>  {return (item?.prodId === product?.data.id)});
    console.log("groupActiveId =",groupActiveId," groupDefaultValue =", groupDefaultValue);

    /* Changes to display Disney Bundle content pop up when selected for the first time
       CETC-145655, CETC-145654 */
    const id = product?.perkDetails?.[0]?.id;
    const otherGrpId = product?.perkDetails?.[1]?.id || '';
    let appleInfoDisplayed = false;
    if (hasCloudStepDown && !cloudStepDownSubmitData && id === "R3552" && add) {
      setCloudStepDownModalOpen(true);
      setCloudStepDownSubmitData({e, perkinfo});
      setCloudStepDownSource("Toggle");
      return;
    } else {
      setCloudStepDownSubmitData(null);
    }
    if (hasYouTubeRemoveModal && !youTubeRemoveData && product?.perkDetails?.[0]?.id === constants.YOUTUBE_PREMIUM && add) {
      setYouTubeRemoveData({e, perkinfo});
      return;
    } else if (youTubeRemoveData) {
      setYouTubeRemoveData(null);
    }
    if(id === 'R4438') {
      if(props?.buildProduct?.perksAddlInfo && props?.buildProduct?.perksAddlInfo[id] && props?.buildProduct?.perksAddlInfo[id]) {
        
      } else {
        dispatch({ type: 'UPDATE_PERKS_ADDL_INFO', value: { R4438: { selectedOnce: true }} });
        if(Object.keys(props?.buildProduct?.perkMessages).length !== 0){
          setDisneyModal(true);
        }else{
          setDisneyModal(true);
          updatePerkSelection({ product, add, flowType, visitId, dispatch, isMnHAuthenticated, isStreamline }); 
          setAdd(!add);    
        }
      }
    }
    let perksInCart = props?.profileCart?.cartData[0]?.perks?.perks;
    const isDisneyLegacyGrandFathered = props.lqState?.runtimeKey?.showDisneyGFModal === 'Y' ? true : false;
    let perkIDGFPerkInCart = false;
    perksInCart?.map(item => {
      if(isGrandfatheredPerk.includes(item?.prodId)){
        perkIDGFPerkInCart = true;
      }
    });
    
    if(props.flowType === "MV" && add && (isGrandfatheredPerk.includes(id)) && perkIDGFPerkInCart){
      if(id === 'R3558'){
        if(isDisneyLegacyGrandFathered){
          setshowGrandfatherConfirmation(true);
          setgrandfatheredPerkId(id);
          return;
        } else {

        }

      } else {
        setshowGrandfatherConfirmation(true);
        setgrandfatheredPerkId(id);
        return;
      }
      
    }
    if(add && id === 'R3559' && (props?.buildProduct?.isNetmaxPromoEligible)) {
      setShowNetmaxConfirmation(true);
      tempVzdlSCData.detail = "Do you still want 12 months of Netflix & Max (with ads)?"
      updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail");
      return;
    }
    if (!add && id === 'R4224') {
      if(isMnHAuthenticated && props?.buildProduct?.perkMessages?.length > 0 &&  props?.buildProduct?.perkMessages?.find((list) => list?.msgId?.includes('GOOGLE_ONE_AI_PREMIUM_1') && list?.applicablePerks === id)){
      setShowGoogleOnePremiumAiModal(true);
      return;
      }
    }
    // Apple product selection check
    if (!add && id === 'R3555') {
      const isAppleOneSelected = selectedProduct?.find((prod) => prod.prodId === 'R3556' || prod.prodId === 'R3557');
      setExisitngAppleProduct(isAppleOneSelected?.prodId || "");
      if (!!isAppleOneSelected) {
        setShowAppleModal(true);
        return;
      } else {
        appleInfoDisplayed = true;
        setShowAppleInfoModal(true);
      }
    } else if (!add && (id === 'R3556' || id === 'R3557')) {
      const isAppleMusicSelected = selectedProduct?.find((prod) => prod.prodId === 'R3555');
      setExisitngAppleProduct(isAppleMusicSelected?.prodId || "");
      if (!!isAppleMusicSelected) {
        setShowAppleModal(true);
        return;
      } else {
        appleInfoDisplayed = true;
        setShowAppleInfoModal(true);
      }
    }

  if (!add && id !== "R3558" && id !== "R4224" && id !== 'R3556' && id !== 'R3557' && id !== 'R3555' && Object.keys(props?.buildProduct?.perkMessages).length !== 0 && props?.buildProduct?.perkMessages.find((list) => list.msgId.includes('WIRELESS') && list.applicablePerks === id) ) {
    if(props?.buildProduct?.perksAddlInfo && props?.buildProduct?.perksAddlInfo[id]){
      updatePerkSelection({ product, add, flowType, visitId, dispatch, isMnHAuthenticated, isStreamline }); 
      setAdd(!add);
      setShowDrawer(!showDrawer);   
    }else{
      setShowConflictModal(true);
    }
  }else{
    if (
      product?.perkDetails?.length >= 2 &&
      (InHomeUtils.isNotNull(groupActiveId) ||
        (InHomeUtils.isNotNull(groupDefaultValue) &&
          (groupDefaultValue === "R3784" || groupDefaultValue === "R3553")))
    ) {
      /**
       * Special case where 2nd option selected in the group (family Sub or group Sub) then turoff the Perk toggle(Drawer).
       */
      let prodId = InHomeUtils.isNotNull(groupActiveId) ? groupActiveId : groupDefaultValue;
      let add = true;
      console.log("DEBUG: handleToggle prodId if", add);
      updatePerkSelection({ product, prodId, add, flowType, visitId, dispatch, isMnHAuthenticated, isStreamline });
      setGroupActiveId(null);
      setGroupDefaultValue(null);
      setAdd(!add);
      setShowDrawer(!showDrawer);  
    } else {
      if(props?.buildProduct?.perksAddlInfo && props?.buildProduct?.perksAddlInfo[id]){
        // Below if check to restrict perk selection when info modal is opened during conflict scenarios
        if((id !== 'R3556' && id !=='R3557' && id !=='R4224') || ((id == 'R3556' || id == 'R3557') && !appleInfoDisplayed)) {
          let prodId = id;
          console.log("DEBUG: handleToggle prodId else", add);
          if(id == 'R3556' || id == 'R3557'){
            if(groupDefaultValue === id){
              prodId = id;
            } else {
              prodId = groupDefaultValue;
            }
          }
          updatePerkSelection({ product, prodId, add, flowType, visitId, dispatch, isMnHAuthenticated }); 
          setAdd(!add);
          setShowDrawer(!showDrawer);
        }
      }else if(Object.keys(props?.buildProduct?.perkMessages).length !== 0 && wirelessPerks?.indexOf(id) == -1){
        // Below if check to restrict perk selection when info modal is opened during conflict scenarios
        if((id !== 'R3556' && id !=='R3557' && id !=='R4224') || ((id == 'R3556' || id == 'R3557') && !appleInfoDisplayed)) {
          let prodId = id;
          if(id == 'R3556' || id == 'R3557'){
            if(groupDefaultValue === id){
              prodId = id;
            } else {
              prodId = groupDefaultValue;
            }
          }
          updatePerkSelection({ product,prodId ,add, flowType, visitId, dispatch, isMnHAuthenticated });
          setAdd(!add);
          setShowDrawer(!showDrawer);
        } else if (id =='R4224' && !isDuplicateGoogleOnePerk) {
          updatePerkSelection({ product, add, flowType, visitId, dispatch, isMnHAuthenticated, isStreamline });
          setAdd(!add);
          setShowDrawer(!showDrawer);  
        }
      }else if(add &&(id === 'R3555' || id === 'R3556' || id === 'R3557')){
        updatePerkSelection({ product, add, flowType, visitId, dispatch, isMnHAuthenticated, isStreamline });
        setAdd(!add);
        setShowDrawer(!showDrawer);      
      }else if(id === 'R3555' || id === 'R3556' || id === 'R3557'){
      }else{
        /* ITT-693500 Adding explicit check for Disney bundle to restrict perk selection when conflict is present -- as Disney has a specific modal to display on first toggle 
        Without this, perk gets added even before Yes, add another subscription btn is clicked and hence it deselects once the Yes btn is clicked*/
        if(id !== 'R3558' || (id === 'R3558' && props?.buildProduct?.perksAddlInfo['R3558']?.selectedOnce) || (id === 'R3558' && !props?.buildProduct?.perkMessages.find((list) => list.msgId.includes('WIRELESS') && list.applicablePerks === id))) {
          updatePerkSelection({ product, add, flowType, visitId, dispatch, isMnHAuthenticated, isStreamline});
          setAdd(!add);
          setShowDrawer(!showDrawer);
        }
      }
    }
  }

    if(buildProduct?.channel?.selectedProduct !== null && buildProduct?.channel?.selectedProduct[0]?.prodId == 'O1563' && product?.data?.id == 'R3559' && !add){
        setshowModal(true);
        console.log('DEBUG perks Channel', buildProduct?.channel, showNFModal);
    }
    if(props?.buildProduct?.enablePerkRedesign && props?.lqState?.streamlineLQ && (product?.perkDetails?.[0]?.id === constants.UNLIMITED_CLOUD_INDIVIDUAL ||
      product?.perkDetails?.[0]?.id === constants.HOME_DEVICE_ADVISOR) && !add)
    {
      setPerksOverlayState(true);
    }
  };
  const handleRadioBtnChange = async(e, labelObj) =>{
    const isStreamline = props.lqState.streamlineLQ ?? false
    const selectedProduct = props.buildProduct?.perks?.selectedProduct || [];
    const selectedPerk = selectedProduct?.find(item => (item?.prodId === product?.perkDetails?.[0]?.id) || (item?.prodId === product?.perkDetails?.[1]?.id));
     let filterLable = labelObj?.filter((p)=>p?.value===e.target.value)
     let toggeleLable = filterLable[0]?.label?.props['children']
    // for Group options We have to remove exisitng perk from the cart and add a new one on radio button changes.
    /* Please don't remove these multiple updateCart calls as this is a requirement. When switching btw radio button perks, previous selection should be removed and new change has to be added. Hence, two updatecart calls are mandatory -- one for removing existing perk and another to add new selection
    */
    
    let add = true;
    let prodId = selectedPerk?.prodId;
    let findUnSelectedProdId = product.perkDetails?.find((item)=> item.id !== prodId);
    if(Object.keys(props?.buildProduct?.perkMessages).length !== 0 && props?.buildProduct?.perkMessages.find((list) => list.msgId.includes('WIRELESS') && list.applicablePerks === findUnSelectedProdId?.id) && !props?.buildProduct?.perksAddlInfo[findUnSelectedProdId?.id]) {
      setConflictFromRadioBtn(true);
      setShowConflictModal(true);
    } else if (hasCloudStepDown && !cloudStepDownSubmitData && findUnSelectedProdId?.id === "R3552") {
      setCloudStepDownModalOpen(true);
      setCloudStepDownSubmitData({e, labelObj});
      setCloudStepDownSource("Radio");
    } else {
      setCloudStepDownSubmitData(null);
      dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Updating your cart"} });
      await updatePerkSelection({product,prodId, add, flowType, visitId, dispatch, isMnHAuthenticated, isStreamline, skipTaggingCall : true});
      setShowDrawer(true)
      setTimeout(()=>{
        add = false;
        prodId = findUnSelectedProdId?.id
        setGroupActiveId(prodId);
        setGroupDefaultValue(prodId);
        updatePerkSelection({product,prodId, add, flowType, visitId, dispatch, isMnHAuthenticated,isStreamline, skipTaggingCall : true})
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false,isLoaderText: "Updating your cart" } })
      },500);
      tempVzdlSCData.detail = product?.data?.displayName;
      //tempVzdlSCData.events = e?"scAdd": "scRemove";
      if(props.lqState.streamlineLQ === true) {
        tempVzdlSCData.name = 'Streamline Buildproducts - Internet & Perks'
        updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail,events,name");
      }else{
        updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail,events");
      } 
      updateSCTags(toggeleLable)
    }
  }
  function handleOpened(opened) {
    setOpened(!opened);
  }
    useEffect(()=>{
    showGoogleOnePremiumAiModal && setShowGoogleOnePremiumAiModal(false)
  },[isOpened])

  const getTitleWidths = id => {
    const isMobile = InHomeUtils.getdeviceType() === 'mobile';
    if(id === constants.DISNEY_BUNDLE) {
      return '90px';
    } else if(id === 'R3552') {
      return isMobile ? '120px' : '180px';
    } else if(id === 'R3731') {
      return isMobile ? '120px' : '138px';
    }else {
      return '130px';
    }
  }

  const formatProdForPerk = (product) => {
    console.log('***** perks ', product);
    let HDPSelected = props?.buildProduct?.perks?.selectedProduct?.findIndex(id=>id?.prodId ==='R3731') > -1 || props?.buildProduct?.perks?.selectedProduct?.findIndex(id=>id?.prodId ==='R3784') > -1
    const empDiscount = isEmployee ? 5 : 0;
    const oldPricesArray = product?.perkDetails?.map(prod => (prod?.perkOriginalPrice - prod?.chargePrice + ((prod?.id == 'R3556' || prod?.id == 'R3557') && isEmployee ? prod?.chargePrice/2  :  empDiscount)).toFixed(2));
    let perkActPrice = product?.perkDetails?.[0]?.perkOriginalPrice;
    const perkMrp = product?.perkDetails?.[0]?.productKeyword?.split?.('MRP:')?.[1];
    if (perkMrp && !(Array.isArray(oldPricesArray) && oldPricesArray?.length > 1)) {
      perkActPrice = parseFloat(perkMrp?.split('|')?.[0]);
    }
    const homeDevice = (product?.perkDetails?.[0]?.id === constants.HOME_DEVICE_ADVISOR);   
    const applesOneIndividual = (product?.perkDetails?.[0]?.id === constants.APPLE_ONE_INDIVIDUAL);
    let applesOneIndividualNewPrice = '';
    if(applesOneIndividual) {
      const applesOneIndividualPerkPrice1 = isEmployee ? parseFloat(product?.perkDetails?.[0]?.price/2)?.toFixed(2) : product?.perkDetails?.[0]?.price;
      if(InHomeUtils.isNotEmpty(product?.perkDetails?.[1]?.id)){
        const gapplesOneIndividualPerkPrice2 = isEmployee && product?.perkDetails?.[1]?.id !== 'R3784' ? product?.perkDetails?.[1]?.price/2 : product?.perkDetails?.[1]?.price;
        applesOneIndividualNewPrice = applesOneIndividualPerkPrice1 + ' - $' + gapplesOneIndividualPerkPrice2
      }
    }
    const unlimitedCloudStorage = (product?.perkDetails?.[0]?.id === constants.UNLIMITED_CLOUD_INDIVIDUAL); 
    let subscriptionGroupPrice =  selectedProduct?.includes(product?.perkDetails?.[0].id) ? product?.perkDetails?.[0]?.price : product?.perkDetails?.[1]?.price 
    let isStreamlineLQ = props.lqState.streamlineLQ
    let elementBg =
      product?.perkDetails?.[0]?.perkTextAppearance?.toLowerCase() == "light"
        ? "dark"
        : "light";
    let obj =   {
      aspectRatio: "1/1",
      backgroundImage: {
        baseUrl: "https://ss7.vzw.com/is/image/VerizonWireless/",
        variant: "small",
        perkName: product?.perkDetails?.[0]?.backgroundImage,
        queryParams: {
          fmt: "webp",
        },
      },
      elementSurface: elementBg,
      variant: "toggle",
      ariaLabel: product?.perkDetails?.[0]?.name,
      title: {
        children: isMobileView &&((product?.perkDetails?.[0]?.id =="R3731" || product?.perkDetails?.[0]?.id =="R3784") && HDPSelected)  ? 'Home Device Support' : product?.perkDetails?.[0]?.displayName ,
        type: "title",
        underline: true,
        width: getTitleWidths(product?.perkDetails?.[0]?.id)
      },
      ...((product?.perkDetails?.[0]?.id === constants?.NETFLIX_AND_MAX && props?.buildProduct?.isNetmaxPromoEligible || (product?.perkDetails?.[0]?.id === constants?.YOUTUBE_PREMIUM && props?.buildProduct?.internet?.selectedProduct?.specialOffers?.some(item => item?.USOCIOSC === constants?.YOUTUBE_PREMIUM_DISCOUNT)))  && {
        banner : {
        children : <StartNotification label={!props?.buildProduct?.isNetmaxPromoEligible ? 'Select YouTube Premium for 6 months on us': 'Select Netflix & Max (With Ads) for 12 months on us '} showTooltip={false} showDetails={product?.perkDetails?.[0]?.id === constants?.YOUTUBE_PREMIUM ? 'youtube':'netmax'} netmaxOnly = {true}/>,
        fillColor: "red",
        padding : "16px",
        icon : {
          name : "tag"
          }
        }
        }),
      ...((product?.perkDetails?.[0]?.id === constants.YOUTUBE_PREMIUM && (buildProduct?.internet?.selectedProduct?.specialOffers?.some?.(o => o?.BsOfferAttrValue === "YOUTUBEPREMIUM_PERK_DISCOUNT") || cart?.cartData?.[0]?.Promotions?.promotions?.find?.(p => p?.offerAttrValue === "YOUTUBEPREMIUM_PERK_MARKER") || cart?.cartData?.[0]?.Promotions?.promotions?.find?.(p => p?.offerAttrValue === "YOUTUBEPREMIUM_PERK_DISCOUNT"))) && {
        banner: {
          children: <StartNotification label="Select YouTube Premium for 6 months on us " showTooltip={false} showDetails="youtube" />,
          fillColor: "red",
          padding: "16px",
          icon: {
            name: "tag"
          }
        }
      }),
      ...(!homeDevice && { oldPrice: {
        price:  Array.isArray(oldPricesArray) && oldPricesArray.length > 1
          ? Math.max(...oldPricesArray)
          : `${(
            perkActPrice - (isEmployee ? parseFloat(product?.perkDetails?.[0]?.chargePrice)/2 : product?.perkDetails?.[0]?.chargePrice)
          ).toFixed(2)?.replace(/\.00$/, '')}`,
          
       ...(product?.perkDetails?.length > 0 && { 
          leadingText: {
            children: props?.lqState?.streamlineLQ ? "Save " :"Save up to"
          },
        }),
        term: "month",
      }
    }),
      ...(homeDevice && { oldPrice: {
        price: isEmployee ? '10' : '5',
        leadingText: {
          children: props?.lqState?.streamlineLQ ? "Save " :"Save up to"
        },
        trailingText: {
          children: props?.lqState?.streamlineLQ ? "": "on Home Device Advisor"
          
        },
       
        term: 'month'
      }}),
      ...(unlimitedCloudStorage && { oldPrice: {
        price: isEmployee ? '8.99' : isStreamlineLQ ? selectedProduct?.includes(product?.perkDetails?.[0].id) ? '3.99' : '4.99' : '3.99',
        leadingText: {
          children:  props?.lqState?.streamlineLQ ? "Save " :"Save up to"
        },
        term: 'month'
      }}),
      ...(applesOneIndividual && isStreamlineLQ && { oldPrice: {
        price: selectedProduct?.includes(product?.perkDetails?.[0].id) ? '9.95' : '5.95',
        leadingText: {
          children:  props?.lqState?.streamlineLQ ? "Save " :"Save up to"
        },
        term: 'month'
      }}),
      newPrice: {
        price: homeDevice ? 
        (isEmployee ? '5 - $25' : isStreamlineLQ && selectedGrpPerkId ? subscriptionGroupPrice :'10 - $25') 
        : unlimitedCloudStorage ? (isEmployee ? '5 - $7.5' : isStreamlineLQ && selectedGrpPerkId ? subscriptionGroupPrice : '10 - $15') 
        : applesOneIndividual ? isStreamlineLQ && selectedGrpPerkId ? subscriptionGroupPrice : applesOneIndividualNewPrice
        : (parseInt(product?.perkDetails?.[0]?.chargePrice) - empDiscount) ,
        term: "month",
      },
      toggle: {
        ariaLabel: product?.data?.displayName,
        onChange: handleToggle,
        on: add,
        controlled: true,
        // disabled : isToggleDisabled,
      },
      image: {
        src: product?.perkDetails?.[0]?.perkLogo,
        alt: product?.perkDetails?.[0]?.name,
      },
    }; 
    // The below changes are for the group Perks Unlimited Cloud and Apple One Drawer funtionality.
    if(product?.perkDetails?.[0]?.id === constants.APPLE_ONE_INDIVIDUAL || 
      product?.perkDetails?.[0]?.id === constants.UNLIMITED_CLOUD_INDIVIDUAL ||
      product?.perkDetails?.[0]?.id === constants.HOME_DEVICE_ADVISOR 
    ){
      const empPrice = isEmployee ? product?.perkDetails?.[0]?.price/2 : 0;
      const groupPerkPrice = isEmployee ? parseFloat(product?.perkDetails?.[0]?.price/2)?.toFixed(2) : product?.perkDetails?.[0]?.price;
      let addRadioButtonGroup= [{
        name: product?.perkDetails?.[0]?.id,
        value: product?.perkDetails?.[0]?.id,
        label: <span className={` ${"GroupLabelWrapper-VDS"} ${"radioBtnLabel"}`}>{`$${groupPerkPrice}/mo ${RadioButtonlabel[product?.perkDetails?.[0]?.id]}`}</span>,
        children: <><div className={'radioBtnLabel'} >
          <Pricing color="green" size="small" leadingText={{"children": "Save" }} 
        price={`${(
         product?.perkDetails?.[0]?.perkOriginalPrice - product?.perkDetails?.[0]?.chargePrice + empPrice).toFixed(2)}`} term="month" />
         </div>
         {(product?.perkDetails?.[0]?.chargePrice !== '15.0' &&  product?.perkDetails?.[0]?.id ==="R3556") &&
         (<Notification type="info"
         id ={"appleNotification"}
         title={ReactHtmlParser(`<span style= "font-weight:400;font-size: .875rem;">Apple One Individual increases to ${isEmployee ? '$7.50': '$15'}/mo on April 17.</span>`)}
         fullBleed={true}
         inline={false}
         disableFocus={true}
         hideCloseButton = {true}></Notification>
         )}
        </>
        }];
        // Add only if the second radio button group their.
         if(InHomeUtils.isNotEmpty(product?.perkDetails?.[1]?.id)){
          const empPrice2 = isEmployee ? product?.perkDetails?.[1]?.price/2 : 0;
          const grpPerk2 = isEmployee && product?.perkDetails?.[1]?.id !== 'R3784' ? product?.perkDetails?.[1]?.price/2 : product?.perkDetails?.[1]?.price;
           addRadioButtonGroup.push({
           name:  product?.perkDetails?.[0]?.id,
           value: product?.perkDetails?.[1]?.id,
           selected:true,
           ariaLabel: product?.perkDetails?.[1]?.id === "R3784"?`${product?.perkDetails?.[1]?.price}/mo Verizon 
          Home Device Protect`:'',
           label: <span className={` ${"GroupLabelWrapper-VDS"} ${"radioBtnLabel1"}`}>{`$${grpPerk2}/mo ${RadioButtonlabel[product?.perkDetails?.[1]?.id]}`}</span>,
           children: <>
                     {product?.perkDetails?.[1]?.id !== "R3784" && <div>
                        <Pricing color="green" size="small" leadingText={{"children": "Save"}} price={`${(
                              product?.perkDetails?.[1]?.perkOriginalPrice - product?.perkDetails?.[1]?.chargePrice + empPrice2).toFixed(2)}`} 
                              term="month" />
                              <span className="addUpTOLabel">{product?.perkDetails?.[1]?.id === "R3553" ? "Includes up to 5 people" : "Add up to 5 other people"}</span>
                        </div>
                     }
                   </>
          })
        }       
      obj.drawer = {
           open: showDrawer,
           children: 
           <div className="perkDrawer">
           <div className="toggleBtnSelectedPerk">
           <RadioButtonGroup
           onChange={(e) => {handleRadioBtnChange(e, addRadioButtonGroup)}}
           defaultValue={groupDefaultValue ? groupDefaultValue : product?.perkDetails?.[0]?.id} 
           value={selectedGrpPerkId}
           data={addRadioButtonGroup} 
           ariaLabel={`${product?.perkDetails?.[0]?.displayName} group option`}
           />
              {product?.perkDetails?.length >= 2 && product?.perkDetails?.every(prod => prod?.id !== constants.UNLIMITED_CLOUD_INDIVIDUAL && prod?.id !== constants.APPLE_ONE_INDIVIDUAL) && 
              <div className="margin-left-large compareDetailsPaddingAlign">
                  <TextLink 
                type="standAlone" 
                surface="light"
                size="small"
                disabled={false}
                onClick={e => {handleClick()}}>
                Compare Details
                </TextLink>
              </div> 
              }
           </div>
           </div>
      }
     

      }
      
    return obj;
  };

  const onPerkClick = (perk) => {
    setPerksOverlayState(true);
    setPerkInfo(perk);
  };

  // Need update this based on the PerkDetailsModal changes
  const displayPerkSelection = () => {
    const cartPerks = props?.cart?.cartData?.[0]?.perks?.perks;
    const selPerks = buildProduct?.perks?.selectedProduct || cartPerks || [];
    const currentPerk = selPerks?.find(perk => perk?.prodId === product?.data?.id);
     
    currentPerk ? setAdd(true) : setAdd(false);  
    if(currentPerk){
     setTheValuesUpOnCartChanges(true,true,product?.data?.id)
     }else if(selPerks?.find(perk => perk.prodId === product?.perkDetails?.[1]?.id)){
      setTheValuesUpOnCartChanges(true,true,product?.perkDetails?.[1]?.id)
     }else{ 
      setAdd(false);
      setShowDrawer(false);
      if(constants.UNLIMITED_CLOUD_GROUP.includes(product?.data?.id)){
        setTheValuesUpOnCartChanges(false,false,constants.UNLIMITED_CLOUD_INDIVIDUAL)
      }
      if(constants.APPLE_ONE_GROUP_IDS.includes(product?.data?.id)){
        setTheValuesUpOnCartChanges(false,false,constants.APPLE_ONE_INDIVIDUAL)
      }
      if(constants.PROTECT_GROUP_IDS.includes(product?.data?.id)){
        setTheValuesUpOnCartChanges(false,false,constants.HOME_DEVICE_ADVISOR)
      }
    }
  };

  const setTheValuesUpOnCartChanges = (toggle,drawer,defaultValue)=>{
    setAdd(toggle)
    setShowDrawer(drawer);
    setGroupDefaultValue(defaultValue);
  }

  const modalPopUpBtnClick = async(newProductId, existingProdId) => {
    if (newProductId === existingProdId) {
      setShowAppleModal(false);
    } else {
      setShowAppleModal(false)
      await updatePerkSelection({product, prodId: existingProdId, add: true, flowType, visitId, dispatch, isMnHAuthenticated});
      setTimeout(()=>{
        updatePerkSelection({product, prodId: newProductId, add: false, flowType, visitId, dispatch, isMnHAuthenticated});
      },500);
    }
  }

  const handleOpenChanges = (e,obj)=>{
    setTogglePerkName(obj?.displayName)
    setTimeout(()=>{
      tempVzdlSCData.detail = 'perks'
      updateDetailValue('perks')
      if(e === true){
        updateSCTags(`${obj?.displayName}`)
      }else{
        if(props?.lqState?.streamlineLQ){
        setPerksOverlayState(!showPerksOverlay);
        }
        if(movesShowPerksOverlay){
          props.movesclosePerksOverlay();
        }
        updateSCTags(`close sign`)
        setTogglePerkName('')
      }
    },1000)
    tempVzdlSCData.detail = 'perks - ' + obj?.displayName
    if(props.lqState.streamlineLQ === true){
      tempVzdlSCData.name = 'Streamline Buildproducts - Internet & Perks'
      updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail,name");
    }else{
      updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail");
    }
  }

  const closePerkDetail =(e,obj)=>{
    setPerksOverlayState(false);
    updateSCTags('close')
    
  }

  const getPerkConflictMsgs = () => {
    let id = product?.perkDetails?.id || product?.perkDetails?.[0]?.id;
    if(conflictFromRadioBtn) {
      const findUnSelectedProdId = product.perkDetails?.find((item)=> item.id !== id);
      id = findUnSelectedProdId?.id;
    }
    let msg = '';
    switch(id) {
      // Netflix & Max
      case 'R3559': 
        msg = `<p>Please note that Netflix (Standard with ads) and Max (With Ads) can each be shared with 2 other people within the same household (at the same address).</p><p>If the users on your account have different addresses, you'll need multiple subscriptions.</p><p>Do you still want to add it?</p>`;
      break;
      // Disney Bundle
      case 'R3558': 
        msg = `<p>Please note the Disney Bundle perk is shareable within the same household (at the same address).</p> <p>If the users on your account have different addresses, you'll need multiple subscriptions.</p> <p>Do you still want to add it?</p>`
        break; 
      // Disney with ads
      case 'R4438': 
        msg = `<p>Please note the Disney Bundle perk is shareable within the same household (at the same address).</p> <p>If the users on your account have different addresses, you'll need multiple subscriptions.</p> <p>Do you still want to add it?</p>`
        break; 
      // Apple One
      case 'R3556': 
        msg = `<p>You can purchase a new Apple One - Individual Subscription if you need another one.</p><p>Do you still want to add it?</p>`;
        break;
      // Apple One Family
      case 'R3557': 
        msg = `<p>Please note the Apple One - Family Subscription can be shared with up to 5 family members.</p><p>Do you still want to add another subscription?</p>`;
        break;
      // Walmart
      case 'R3554': 
        msg = `<p>Please note the Walmart+ perk is shareable within the same household (at the same address).</p><p>If the users on your account have different addresses, you'll need multiple subscriptions.</p><p>Do you still want to add it?</p>`;
        break;
      // Apple Music
      case 'R3555': 
        msg = `<p>Please note the Apple Music Family subscription can be shared with up to 5 family members.</p><p>Do you still want to add another subscription?</p>`
        break;
      // Youtube Premium
      case 'R3680': 
        msg = `<p>Please note that the YouTube Premium family subscription can be shared with 5 other people within the same household (at the same address).</p><p>If the users on your account have different addresses, you'll need multiple subscriptions.</p><p>Do you still want to add it?</p>`
        break;
      // +play
      case 'R3551': 
        msg = `<p>You can purchase a new subscription to increase your credit for +play services.</p><p>Do you still want to add it?</p>`;
        break;
       // Unlimited cloud storage
      case 'R3552': 
      // Unlimited cloud group
      case 'R3553': 
        msg = `<p>You can purchase a new subscription if you need separate cloud storage access.</p><p>Do you still want to add it?</p>`;
        break;
      // Verizon Home Advisor
      case 'R3731': 
      break;
      default:
        msg = `<p>Please note the ${product?.data?.name} perk is shareable within the same household (at the same address).</p><p>If the users on your account have different addresses, you'll need multiple subscriptions.</p><p>Do you still want to add it?</p>`
        break;
    }
    return msg;
  }

  const getPerkRecommendedLabels = () => {
    // CETC-147254 removed from non change flow
    // if (buildProduct?.internet?.mnhSignupIndicator === "Y" && buildProduct?.emberInfo?.isEmberFlow) {
    //   const perkCreditArray = product?.perkDetails?.map?.(p => emberMnHPerkCreditOfferAttributes?.[p?.id])?.filter?.(p => p);
    //   const hasCartPerkCredit = props?.cart?.cartData?.[0]?.Promotions?.promotions?.find?.(p => Array.isArray(perkCreditArray) && p?.offerAttr === "SPCLDISCOUNT" && perkCreditArray?.includes?.(p?.offerAttrValue));
    //   if (hasCartPerkCredit)
    //     return <StartNotification label="Mobile + Home Perk Credit applied" />;
    // }
    if(product?.perkDetails[0]?.id == constants.DISNEY_BUNDLE && buildProduct?.isDisneyPromoPresent) {
      return <StartNotification label='Get 12 months on us ' showTooltip={false} showDetails='disney'/>;
    } else if (product?.perkDetails?.[0]?.id === constants.YOUTUBE_PREMIUM && cart?.cartData?.[0]?.Promotions?.promotions?.find?.(p => p?.offerAttrValue === "YOUTUBEPREMIUM_PERK_MARKER" || p?.offerAttrValue === "YOUTUBEPREMIUM_PERK_DISCOUNT") && buildProduct?.enablePerkRedesign && props?.lqState?.streamlineLQ) {
      return <StartNotification label='&#x2605; Your special gift - 6 months on us ' showTooltip={false} showDetails="youtube" style={{ color: "black" }} />;
    }  else {
      return <></>;
    }
  };

  // Netmax confirmation modal CTA actions
  const netmaxModalCTAClick = (action) => {
    console.log('***** perk modal action ', action);
    if(action === 'keep') {
      setShowNetmaxConfirmation(false);
      updateDetailValue('Do you still want 12 months of Netflix & Max (with ads)?')
      updateSCTags('Keep this perk')
      setAdd(true);
    } else if(action === 'later') {
      setShowNetmaxConfirmation(false);
      updateDetailValue('Do you still want 12 months of Netflix & Max (with ads)?')
      updateSCTags('Get this perk later')
      updatePerkSelection({ prodId: 'R3559', add: true, dispatch: dispatch, visitId: visitId })
    } else if(action === 'otherOffer') {
      setShowNetmaxConfirmation(false);
      updatePerkSelection({ prodId: 'R3559', add: true, dispatch: dispatch, visitId: visitId })
      dispatch({ type: 'TOGGLE_DATA_SPLOFFER_ACCOR', value: '' });
      buildProductAction.focusAccordion("specialofferAccordionBlock", dispatch)
      focusAnimation(1500);
    }
  };

  const handleNetmaxClose = (netmaxState) => {
    if(netmaxState === false){
      updateDetailValue('Do you still want 12 months of Netflix & Max (with ads)?')
      updateSCTags('close sign')
    }
  }

  useEffect(() => {
    const profileAdd = product?.data?.status === "ON_PROFILE" && props.cart?.cartData?.[0]?.removedperks?.removedPerks.findIndex((item) => item?.prodId === product?.data?.id) === -1
      ? true
      : (props.cart?.cartData?.[0]?.perks?.perks?.map(p => p.prodId)?.includes(product?.perkDetails?.[0]?.id)) || showDrawer
    if (add !== profileAdd) {
      setAdd(profileAdd);
    }
  }, [product, props?.cart?.cartData, showDrawer]);

  return (
    <>
    {showLoader ? 
      <Loader active={true} surface="light" fullscreen={false} /> :
    <div id={`PERK${product?.data?.id}`} className={"accordionMNTileDiv" + perkRecLabel}>
      {
        getPerkRecommendedLabels()
      }
      {/* { product.perkDetails[0].id == constants.NETFLIX_AND_MAX ? <StartNotification label="Recommended" showTooltip={false}/> 
    : (product.perkDetails[0].id == constants.WALMART_PLUS_MEMBERSHIP ? <StartNotification label="Get 6 months on us" showTooltip={true} tooltipTitle="WALMART+ MEMBERSHIP"  tooltipMessage="Get 6 months on us" /> 
    : <StartNotification showTooltip={false} label='Recommended' dummyRibbon={true}/>)
    }  */}
      <div className={(product?.data?.id == 'R3559' && product?.data?.id == 'R3582') || (product?.data?.id == 'R3559' && props?.buildProduct?.isNetmaxPromoEligible) || (product?.perkDetails?.[0]?.id === constants.YOUTUBE_PREMIUM && (buildProduct?.internet?.selectedProduct?.specialOffers?.some?.(o => o?.BsOfferAttrValue === "YOUTUBEPREMIUM_PERK_DISCOUNT") || cart?.cartData?.[0]?.Promotions?.promotions?.find?.(p => p?.offerAttrValue === "YOUTUBEPREMIUM_PERK_MARKER") || cart?.cartData?.[0]?.Promotions?.promotions?.find?.(p => p?.offerAttrValue === "YOUTUBEPREMIUM_PERK_DISCOUNT"))) ? "perks_tileNetmax" : 'perks_tile'}>
   
      {
      (props?.buildProduct?.enablePerkRedesign && props?.lqState?.streamlineLQ)? 
       <PerkStreamline  
       {...formatProdForPerk(product)}  onClick={handleClick}></PerkStreamline>: movesShowPerksOverlay  ? '' :
       <PerkTileComponent
          {...formatProdForPerk(product)}
          onClick={handleClick}
        />}

            {
              showGrandfatherConfirmation && <OpenGrandfatheredPerkModal perkIDGF = {grandfatheredPerkId} />
            }
           {/* {showNFModal && <OpenNetFlixModal/>} */}
        {/* Todo changes  */}
        { showAppleModal && (
          <AppleModal 
            prodId = {exisitngAppleProduct}
            onClose={() => {setShowAppleModal(false);}}
            onBtnClick = {(newProductId, existingProdId)=>{modalPopUpBtnClick(newProductId, existingProdId)}}
            onLinkClick = {(newProductId, existingProdId)=>{modalPopUpBtnClick(newProductId, existingProdId)}}
          />)
        }
        {showAppleInfoModal && (
          <Modal opened={true} disableOutsideClick={true} surface="light" fullScreenDialog={false} disableAnimation={false} ariaLabel="Apple device disclosure"  width={'35vw'}>
            <ModalTitle>
              Important information
            </ModalTitle>
            <ModalBody>
              <p>To start enjoying this product, you must have an iPhone with iOS 16.0 or later, an iPad with iPadOS 16.0 or later, or a Mac with macOS 13.1 (Ventura) or later.</p>
              <Button size="100" primary={true} id="apple-disclosure-accept" width="100" onClick={() =>{
                setShowAppleInfoModal(false);
                const id = product?.perkDetails?.[0]?.id;
                if( Object.keys(props?.buildProduct?.perkMessages).length !== 0 && props?.buildProduct?.perkMessages.find((list) => list.msgId.includes('WIRELESS') && list.applicablePerks === id)){              
                  if(props?.buildProduct?.perksAddlInfo && props?.buildProduct?.perksAddlInfo[id]){
                    updatePerkSelection({ product, add, flowType, visitId, dispatch, isMnHAuthenticated });
                    setAdd(!add);
                    setShowDrawer(!showDrawer);                
                  }else{
                    setShowConflictModal(true);
                  }
                }else if (id !== "R3555"){
                  /** after selcteing the apple music perks card is removeing prodff-36357 */
                 updatePerkSelection({ product, add, flowType, visitId, dispatch, isMnHAuthenticated });
                  setAdd(!add);
                  setShowDrawer(!showDrawer);                
                };
                if(props?.buildProduct?.enablePerkRedesign && props?.lqState?.streamlineLQ){setPerksOverlayState(true)};
              }}>Got it</Button> 
            </ModalBody>
          </Modal>
        )}
        {showGoogleOnePremiumAiModal && (
          <Modal opened={true} onOpenedChange={(opened)=> handleOpened(opened)}  disableOutsideClick={true} surface="light" fullScreenDialog={false} disableAnimation={false} ariaLabel="Google One AI Premium"  width={'35vw'}>
            <ModalTitle>
              You already have this perk on another mobile line.
            </ModalTitle>
            <ModalBody>
              <p>Your 2 TB of cloud storage can be shared with 5 family members. Please note Gemini can't be shared.</p>
              <p>Do you still want to add it?</p>
              
              <div style={{ marginTop: '12px' }}>
                <Button
                  id="google-one-ai-premium-accept"
                  width="100%"
                  use='primary'
                  onClick={() => {
                    let add = false;
                    updatePerkSelection({ product, add, flowType, visitId, dispatch, isMnHAuthenticated });
                    setAdd(!add);
                    setShowDrawer(!showDrawer);  
                    setShowGoogleOnePremiumAiModal(false);
                  }}>
                  Yes, add another subscription
                </Button>
              </div>
              <div style={{ marginTop: '12px' }}>
                <Button
                  id="google-one-ai-premium-deny"
                  width="100%"
                  use='secondary'
                  onClick={() => {
                    setShowGoogleOnePremiumAiModal(false);
                  }}>
                  No, don't add another
                </Button>
              </div>
            </ModalBody>
          </Modal>
        )}
        {hasCloudStepDown &&
          <CloudStepDownModal
            opened={isCloudStepDownModalOpen}
            source={cloudStepDownSource}
            onOpenedChange={(opened) => setCloudStepDownModalOpen(opened)}
            onCancel={() => setCloudStepDownSubmitData(null)}
            onSubmit={(e) => {
              if (cloudStepDownSource === "Toggle") {
                handleToggle(cloudStepDownSubmitData?.e, cloudStepDownSubmitData?.perkinfo);
              } else {
                handleRadioBtnChange(cloudStepDownSubmitData?.e, cloudStepDownSubmitData?.labelObj)
              }
            }}
            perkDetails={product?.perkDetails}
          />
        }

        {showPerksOverlay && (
          <PerkDetailOverlay
            selectedProductId={movesShowPerksOverlay ? perkList?.[0]?.data?.id : product.perkDetails[0].id}
            selectedPerk={perkInfo}
            showModal={showPerksOverlay}
            uniqPerkList ={(props?.buildProduct?.enablePerkRedesign && props?.lqState?.streamlineLQ)?uniqPerkList.filter((producta)=> (producta?.data?.id === product.perkDetails[0].id )):uniqPerkList}
            perkList={(props?.buildProduct?.enablePerkRedesign && props?.lqState?.streamlineLQ)?perkList.filter((producta)=> (producta?.data?.id === product.perkDetails[0].id )):
              perkList.filter((product)=> {return !constants.DONOTSHOW_PERK_TILE_GROUP.includes(product?.data?.id)})}
            perkListobj={perkListobj}
            variant="toggle"
            changeFn={(e)=>{handleToggle(e,perkInfo)}}   
            selectedProduct={selectedProduct}
            visitId={visitId}
            flowType={flowType}
            dispatch={dispatch}
            toggleOn={add}
            // isToggleDisabled={isToggleDisabled}
            isMnHAuthenticated={isMnHAuthenticated}
            selectedPerks={props.buildProduct?.perks?.selectedProduct}
            profileCart={props?.profileCart}
            setPerksOverlayState={setPerksOverlayState}
            onClose ={(e)=>{closePerkDetail(e,product.perkDetails[0])}} 
            onOpenedChange = {(e)=>{handleOpenChanges(e,product.perkDetails[0])}} 
            isEmployee={isEmployee}
            perkModalName = {togglePerkName}
            buildProduct={buildProduct}
            isStreamline = {props.lqState.streamlineLQ}
            movesShowPerksOverlay = {movesShowPerksOverlay}
            showApplePriceUP={isshowApplePriceUP}
            selectedGrpPerkId = {selectedGrpPerkId}
            selectedProductRadio = {product?.perkDetails}
            movesPerkFlow = {props?.movesPerkFlow}
            handleMovePerksBtn ={props?.handleMovePerksBtn}
            cart = {props?.cart}
          />
        )}

        {
          showNetmaxConfirmation && (
            <NetMaxConfirmationModal
              netmaxModalCTAClick={netmaxModalCTAClick}
              onOpenedChange={(opened) =>{setShowNetmaxConfirmation(opened);handleNetmaxClose(opened)}}
              buildProduct = {props?.buildProduct}
            />
          )
        }

        {
          disneyModal && <PerkAddlInfo closeModal={setDisneyModal} conflictMessage={setShowConflictModal} perkMessages={props?.buildProduct?.perkMessages} id={product?.perkDetails?.[0]?.id}/>
        }
        {showConflictModal && (
          <Modal
            opened={true}
            disableOutsideClick={true}
            surface="light"
            fullScreenDialog={false}
            disableAnimation={false}
            ariaLabel="Apple device disclosure">
            <ModalTitle>Your account already has {product?.data?.displayName || "Verizon Cloud"} on a mobile line.</ModalTitle>
            <ModalBody>
              <Body size='medium'>
                {
                  ReactHtmlParser(getPerkConflictMsgs())
                }
              </Body>
            </ModalBody>
            <ModalFooter children={
              <>
                <Button
                use='primary'
                id="apple-disclosure-accept"
                width="100%"
                onClick={async () => {
                  if(conflictFromRadioBtn) {
                    const selectedPerk = props.buildProduct?.perks?.selectedProduct?.find(item => (item?.prodId === product?.perkDetails?.[0]?.id) ||  (item?.prodId === product?.perkDetails?.[1]?.id));
                    let prodId = selectedPerk?.prodId;
                    const findUnSelectedProdId = product.perkDetails?.find((item)=> item.id !== prodId);
                    let add = true;
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Updating your cart"} });
                    await updatePerkSelection({product, prodId, add, flowType, visitId, dispatch, isMnHAuthenticated });
                    setShowDrawer(true);
                    setTimeout(()=>{
                      add = false;
                      prodId = findUnSelectedProdId?.id
                      setGroupActiveId(prodId);
                      setGroupDefaultValue(prodId);
                      updatePerkSelection({product,prodId, add, flowType, visitId, dispatch, isMnHAuthenticated})
                      dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false,isLoaderText: "Updating your cart" } })
                    },500);
                    tempVzdlSCData.detail = product?.data?.displayName;
                    //tempVzdlSCData.events = e?"scAdd": "scRemove";
                    if(props.loopQual.streamlineLQ) {
                      tempVzdlSCData.name = 'Streamline Buildproducts - Internet & Perks'
                      updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail,events,name");
                    }else{
                      updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail,events");
                    }
                    dispatch({ type: 'UPDATE_PERKS_ADDL_INFO', value: { [findUnSelectedProdId.id] : { selectedOnce: true }} });
                    // updateSCTags(toggeleLable)
                  } else if (
                    product?.perkDetails?.length >= 2 &&
                    (InHomeUtils.isNotNull(groupActiveId) ||
                      (InHomeUtils.isNotNull(groupDefaultValue) &&
                        (groupDefaultValue === "R3784" || groupDefaultValue === "R3553")))
                  ) {
                    /**
                     * Special case where 2nd option selected in the group (family Sub or group Sub) then turoff the Perk toggle(Drawer).
                     */
                    let prodId = InHomeUtils.isNotNull(groupActiveId) ? groupActiveId : groupDefaultValue;
                    let add = true;
                    console.log("DEBUG: handleToggle prodId if", add);
                    updatePerkSelection({ product, prodId, add, flowType, visitId, dispatch, isMnHAuthenticated });
                    setGroupActiveId(null);
                    setGroupDefaultValue(null);
                    //setShowDrawer(true)
                  } else {
                    console.log("DEBUG: handleToggle prodId else", add);
                    updatePerkSelection({ product, add, flowType, visitId, dispatch, isMnHAuthenticated });
                  }
                  let id = product?.perkDetails?.id || product?.perkDetails[0]?.id;
                  if(!conflictFromRadioBtn) {
                    dispatch({ type: 'UPDATE_PERKS_ADDL_INFO', value: { [id] : { selectedOnce: true }} });
                  }
                  setAdd(!add);
                  setShowDrawer(!showDrawer);
                  setShowConflictModal(false);
                }}>
                Yes, add another subscription
              </Button>
              <div style={{ marginTop: '12px' }}>
                <Button
                  id="apple-disclosure-accept"
                  width="100%"
                  use='secondary'
                  onClick={() => {
                    setShowConflictModal(false);
                    if(conflictFromRadioBtn) {
                      setConflictFromRadioBtn(false);
                    }
                    if (disneyModal) {
                      setDisneyModal(false);
                    }
                  }}>
                  No, don't add another
                </Button>
              </div>
              </>
            } />
          </Modal>
        )}
            {(hasYouTubeRemoveModal && product?.perkDetails?.[0]?.id === constants.YOUTUBE_PREMIUM) && (
              <React.Suspense fallback={<></>} >
                <YouTubePremiumRemoveModal
                  isMobile={isMobileView}
                  onOpenedChange={(modalOpened) => {
                    if (!modalOpened) {
                      setYouTubeRemoveData(null);
                    }
                  }}
                  opened={youTubeRemoveData ? true : false}
                  onPrimary={() => {
                    setYouTubeRemoveData(null);
                  }}
                  onClose={() => {
                    handleToggle(youTubeRemoveData?.e, youTubeRemoveData?.perkinfo);
                  }}
                />
              </React.Suspense>
            )}
      </div>
      {<div className={streamlinePagePerk || isMobileView ? "" : "perks_tile_footer"}>
        {((product?.data?.id === "R3731" || product?.data?.id === "R3784") && buildProduct?.internet?.mnhSignupIndicator === "Y" && buildProduct?.emberInfo?.isEmberFlow) && (
          <div className="emberHomeProtectPerkDisclaimer">
            <p>Home Device Support & Protection is not eligible for the Mobile + Home Perk Credit.</p>
          </div>
        )}
      </div>}
    </div>
}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    buildProduct: state.buildProduct,
    visitId: state.app.visitId,
    cart: state.cart,
    profileCart:state.profileCart,
    save: state.save,
    flowType: state.app.flowType,
    moveExp: state.moveExp.moveLandingExp,
    isFCPflow: state.loopQual.isFCPflow,
    isDoFlow: state.loopQual.doFlowDetails.isDoFlow,
    zip: state.loopQual.selectedState ? state.loopQual.selectedState.zip : "",
    tarCode: state.loopQual.selectedState
      ? state.loopQual.lqResponse.tarcode
      : "",
    cust_opt: state.moveExp.cust_opt,
    isFcpInProfile: state.loopQual.isFcpInProfile,
    lqState: state.loopQual,
    ecProfileCart: state.ecProfileCart
  };
};

export default connect(mapStateToProps)(PerkTile);
